import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'disclaimer',
    templateUrl: 'disclaimer.component.html',
    imports: [RouterLink]
})
export class DisclaimerComponent {
  @Input() fxRate = '';
}
